var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "folder-files" },
    [
      _c("image-toolbox", {
        attrs: {
          selectedNum: _vm.selectedNum,
          loadedAllImageNum: _vm.folders.length + _vm.files.length,
          selectedImages: _vm.selectedFiles,
          selectedFolders: _vm.selectedFolders,
          mode: "folder"
        },
        on: {
          moveToFolderFinished: function($event) {
            return _vm.moveToFolderFinished(arguments[0], arguments[1])
          },
          closeSelected: _vm.closeSelected,
          deleteSelectedImages: _vm.deleteSelectedImages,
          selectLoaded: _vm.selectLoadedImage
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "view-content folder-view-content clearfix" },
        [
          _c("div", { staticClass: "fixed-line clearfix" }, [
            _vm.showFolders
              ? _c("div", { staticClass: "fixed-left" }, [
                  _c("i", {
                    staticClass: "icon-add",
                    on: { click: _vm.showInputPop }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.showFolders
              ? _c("div", { staticClass: "fixed-left" }, [
                  _c(
                    "span",
                    { staticClass: "go-back", on: { click: _vm.goRootFolder } },
                    [_vm._v(_vm._s(_vm.$t("list.back")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "folder-name" }, [
                    _vm._v(_vm._s(_vm.folderName))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "total-item" }, [
              _vm._v(
                _vm._s(_vm.$t("list.total")) +
                  " " +
                  _vm._s(_vm.filesTotalNum) +
                  " " +
                  _vm._s(_vm.$t("list.items"))
              )
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.folders, function(folder, folderIndex) {
            return _c(
              "div",
              {
                key: folder.id,
                staticClass: "view-item folder-item",
                class: {
                  selected: folder.selected,
                  "show-default-folder-img": folder.small === null,
                  entered: folder.entered
                },
                attrs: { title: folder.name },
                on: {
                  click: function($event) {
                    return _vm.enterFolder(folderIndex, folder.id, folder.name)
                  }
                }
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c("div", { staticClass: "layer layer-under" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-middle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-upper" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "img-wrap" }, [
                    _c("img", {
                      staticClass: "defaul-folder-img",
                      attrs: {
                        src: require("../../assets/images/default_folder.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: folder.small,
                          expression: "folder.small"
                        }
                      ],
                      staticClass: "folder-img",
                      style: {
                        width: folder.showWidth + "px",
                        height: folder.showHeight + "px"
                      },
                      attrs: { alt: "" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-item-t folder-msg" }, [
                    _c("i", { staticClass: "icon-folder" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "folder-title" }, [
                      _vm._v(_vm._s(folder.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "checkbox",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.folderCheckboxClick(folderIndex)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "folder-mark" })
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.files, function(file, fileIndex) {
            return _c(
              "div",
              {
                key: file.id,
                staticClass: "view-item folder-item",
                class: { selected: file.selected }
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "img-file",
                      style: {
                        width: file.showWidth + "px",
                        height: file.showHeight + "px"
                      }
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: file.middle,
                            expression: "file.middle"
                          }
                        ],
                        attrs: { alt: "" },
                        on: {
                          click: function($event) {
                            return _vm.showImage(fileIndex)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "checkbox",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.fileCheckboxClick(fileIndex)
                          }
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          }),
          _vm._v(" "),
          _vm.showNoFile
            ? _c("div", { staticClass: "no-file" }, [
                _c("div", { staticClass: "no-file-main" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/images/no_file.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.$t("list.noFile")))])
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-loading", class: { show: _vm.dataLoading } },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("loading", { attrs: { loading: true } }),
              _vm._v(" "),
              _c("span", { staticClass: "data-loading-text" }, [
                _vm._v(_vm._s(_vm.$t("list.loading")))
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("player", {
        ref: "player",
        attrs: {
          show: _vm.playerShow,
          images: _vm.swiperImages,
          allIndex: _vm.playerStartIndex
        },
        on: {
          closeButtonClick: _vm.closeImagePlayer,
          pageModeChanged: function($event) {
            return _vm.imageModeChanged(arguments[0], arguments[1])
          },
          reloadPlayerData: function($event) {
            return _vm.resetPlayerData(arguments[0])
          }
        }
      }),
      _vm._v(" "),
      _vm.inputPop
        ? _c("input-pop", {
            on: { closeInputPop: _vm.closeInputPop, newFolder: _vm.newFolder }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("processing", { attrs: { processing: _vm.processing } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bced24e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bced24e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Et/FolderFiles.vue
// module id = null
// module chunks = 